export default "__VITE_ASSET__1a439a7b__"